import {ResourceParams} from "../resources";

export type ProductCardModalResourceType =
  'product-cards-weekly-ratings' |
  'certificates' |
  'declarations' |
  'factory-bank-details' |
  'turnkey-cost-to-warehouse' |
  'turnkey-cost-to-marketplace' |
  'technical-conclusions' |
  'product-compositions' |
  'main-photos' |
  'listings' |
  'rich-contents' |
  'base-videos' |
  'ai-videos' |
  'package-design-details' |
  'raw-photos' |
  'raw-videos' |
  'other-content' |
  'banners' |
  'social-media' |
  'usp' |
  'product-values' |
  'product-descriptions' |
  'product-usage-rules' |
  'website-links' |
  'website-backups' |
  'marketing-drafts' |
  'unit-economics-calculations' |
  'product-card-quality-control-approvals';

export const productCardModalResources: {
  [key in ProductCardModalResourceType]: ResourceParams
} = {
  'product-cards-weekly-ratings': {
    key: 'product-cards-weekly-ratings',
    name: 'Расчётный рейтинг продукта',
    path: 'product-cards-weekly-ratings'
  },
  'certificates': {
    key: 'certificates',
    name: 'Сертификат',
    path: 'certificates'
  },
  'declarations': {
    key: 'declarations',
    name: 'Декларация',
    path: 'declarations'
  },
  'factory-bank-details': {
    key: 'factory-bank-details',
    name: 'Завод-изготовитель',
    path: 'factory-bank-details'
  },
  'turnkey-cost-to-warehouse': {
    key: 'turnkey-cost-to-warehouse',
    name: 'Себестоимость под ключ до склада',
    path: 'turnkey-cost-to-warehouse'
  },
  'turnkey-cost-to-marketplace': {
    key: 'turnkey-cost-to-marketplace',
    name: 'Себестоимость под ключ до маркетплейса',
    path: 'turnkey-cost-to-marketplace'
  },
  'technical-conclusions': {
    key: 'technical-conclusions',
    name: 'Техническое заключение',
    path: 'technical-conclusions'
  },
  'product-compositions': {
    key: 'product-compositions',
    name: 'Состав продукта',
    path: 'product-compositions'
  },
  'main-photos': {
    key: 'main-photos',
    name: 'Первая картинка',
    path: 'main-photos'
  },
  'listings': {
    key: 'listings',
    name: 'Листинги',
    path: 'listings'
  },
  'rich-contents': {
    key: 'rich-contents',
    name: 'Рич-контент',
    path: 'rich-contents'
  },
  'base-videos': {
    key: 'base-videos',
    name: 'Видео основа',
    path: 'base-videos'
  },
  'ai-videos': {
    key: 'ai-videos',
    name: 'Видео ИИ (7 сек)',
    path: 'ai-videos'
  },
  'package-design-details': {
    key: 'package-design-details',
    name: 'Этикетки/инструкции/коробки',
    path: 'package-design-details'
  },
  'raw-photos': {
    key: 'raw-photos',
    name: 'Сырой фото-контент',
    path: 'raw-photos'
  },
  'raw-videos': {
    key: 'raw-videos',
    name: 'Сырой видео-контент',
    path: 'raw-videos'
  },
  'other-content': {
    key: 'other-content',
    name: 'Прочее',
    path: 'other-content'
  },
  'banners': {
    key: 'banners',
    name: 'Баннеры',
    path: 'banners'
  },
  'social-media': {
    key: 'social-media',
    name: 'Соц. сети',
    path: 'social-media'
  },
  'usp': {
    key: 'usp',
    name: 'УТП',
    path: 'usp'
  },
  'product-values': {
    key: 'product-values',
    name: 'Ценности продукта',
    path: 'product-values'
  },
  'product-descriptions': {
    key: 'product-descriptions',
    name: 'Описание продукта',
    path: 'product-descriptions'
  },
  'product-usage-rules': {
    key: 'product-usage-rules',
    name: 'Правила использования продукта',
    path: 'product-usage-rules'
  },
  'website-links': {
    key: 'website-links',
    name: 'Ссылки',
    path: 'website-links'
  },
  'website-backups': {
    key: 'website-backups',
    name: 'Сайт БЭКАП',
    path: 'website-backups'
  },
  'marketing-drafts': {
    key: 'marketing-drafts',
    name: 'Промежуточные наработки',
    path: 'marketing-drafts'
  },
  'unit-economics-calculations': {
    key: 'unit-economics-calculations',
    name: 'Расчёты юнит-экономики',
    path: 'unit-economics-calculations'
  },
  'product-card-quality-control-approvals': {
    key: 'product-card-quality-control-approvals',
    name: 'Согласования контроля качества',
    path: 'product-card-quality-control-approvals'
  }
};

export type ProductCardModalFilesResourceType =
  'product-package-files' |
  'declaration-files' |
  'certificate-files' |
  'technical-conclusion-files' |
  'product-composition-files' |
  'main-photo-files' |
  'listing-files' |
  'rich-content-files' |
  'base-video-files' |
  'ai-video-files' |
  'package-design-details-files' |
  'raw-photo-files' |
  'raw-video-files' |
  'other-content-files' |
  'banner-files' |
  'social-media-files' |
  'website-backup-files' |
  'turnkey-cost-to-marketplace-files' |
  'turnkey-cost-to-warehouse-files' |
  'unit-economics-calculations-files';

export const productCardModalFilesResources: {
  [key in ProductCardModalFilesResourceType]: ResourceParams
} = {
  'product-package-files': {
    key: 'product-package-files',
    name: 'Файлы упаковки',
    path: 'product-package-files'
  },
  'declaration-files': {
    key: 'declaration-files',
    name: 'Файлы декларации',
    path: 'declaration-files'
  },
  'certificate-files': {
    key: 'certificate-files',
    name: 'Файлы сертификата',
    path: 'certificate-files'
  },
  'technical-conclusion-files': {
    key: 'technical-conclusion-files',
    name: 'Файлы технического заключение',
    path: 'technical-conclusion-files'
  },
  'product-composition-files': {
    key: 'product-composition-files',
    name: 'Файлы состава продукта',
    path: 'product-composition-files'
  },
  'main-photo-files': {
    key: 'main-photo-files',
    name: 'Файлы первой картинки',
    path: 'main-photo-files'
  },
  'listing-files': {
    key: 'listing-files',
    name: 'Файлы листинга',
    path: 'listing-files'
  },
  'rich-content-files': {
    key: 'rich-content-files',
    name: 'Файлы рич-контента',
    path: 'rich-content-files'
  },
  'base-video-files': {
    key: 'base-video-files',
    name: 'Файлы видео основа',
    path: 'base-video-files'
  },
  'ai-video-files': {
    key: 'ai-video-files',
    name: 'Файлы видео ИИ (7 сек)',
    path: 'ai-video-files'
  },
  'package-design-details-files': {
    key: 'package-design-details-files',
    name: 'Файлы этикетки/инструкции/коробки',
    path: 'package-design-details-files'
  },
  'raw-photo-files': {
    key: 'raw-photo-files',
    name: 'Файлы сырого фото-контернта',
    path: 'raw-photo-files'
  },
  'raw-video-files': {
    key: 'raw-video-files',
    name: 'Файлы сырого видео-контернта',
    path: 'raw-video-files'
  },
  'other-content-files': {
    key: 'other-content-files',
    name: 'Файлы Прочие',
    path: 'other-content-files'
  },
  'banner-files': {
    key: 'banner-files',
    name: 'Файлы баннера',
    path: 'banner-files'
  },
  'social-media-files': {
    key: 'social-media-files',
    name: 'Файлы соц. сети',
    path: 'social-media-files'
  },
  'website-backup-files': {
    key: 'website-backup-files',
    name: 'Файлы БЭКАП',
    path: 'website-backup-files'
  },
  'turnkey-cost-to-marketplace-files': {
    key: 'turnkey-cost-to-marketplace-files',
    name: 'Файлы себестоимости под ключ до маркетплейса',
    path: 'turnkey-cost-to-marketplace-files'
  },
  'turnkey-cost-to-warehouse-files': {
    key: 'turnkey-cost-to-warehouse-files',
    name: 'Файлы себестоимости под ключ до склада',
    path: 'turnkey-cost-to-warehouse-files'
  },
  'unit-economics-calculations-files': {
    key: 'unit-economics-calculations-files',
    name: 'Файлы расчётов юнит-экономики',
    path: 'unit-economics-calculations-files'
  }
};

export type ProductCardModalTableNeedProductIdResourceType =
  'hypotheses-product-card' |
  'notes-product-card';

export const productCardModalTableNeedProductIdResources: {
  [key in ProductCardModalTableNeedProductIdResourceType]: ResourceParams
} = {
  'hypotheses-product-card': {
    key: 'hypotheses-product-card',
    name: 'Книга Гипотез',
    path: 'hypotheses-product-card'
  },
  'notes-product-card': {
    key: 'notes-product-card',
    name: 'Заметки',
    path: 'notes-product-card'
  }
};

export type ProductCardModalTableResourceType =
  'technical-parameters-product-card' |
  'design-blocks' |
  'marketing-blocks' |
  ProductCardModalTableNeedProductIdResourceType |
  'advertisement-integrations' |
  'price-levels-product-card' |
  'components' |
  'testing-results' |
  'product-card-quality-controls';

export const productCardModalTableResources: {
  [key in ProductCardModalTableResourceType]: ResourceParams
} = {
  'technical-parameters-product-card': {
    key: 'technical-parameters-product-card',
    name: 'Технические параметры (закупки + продукт)',
    path: 'technical-parameters-product-card'
  },
  'design-blocks': {
    key: 'design-blocks',
    name: 'Дизайнерский Блок',
    path: 'design-blocks'
  },
  'marketing-blocks': {
    key: 'marketing-blocks',
    name: 'Маркетинговый Блок',
    path: 'marketing-blocks'
  },
  ...productCardModalTableNeedProductIdResources,
  'advertisement-integrations': {
    key: 'advertisement-integrations',
    name: 'Рекламные интеграции',
    path: 'advertisement-integrations'
  },
  'price-levels-product-card': {
    key: 'price-levels-product-card',
    name: 'Уровни цены',
    path: 'price-levels-product-card'
  },
  'components': {
    key: 'components',
    name: 'Компоненты',
    path: 'components'
  },
  'testing-results': {
    key: 'testing-results',
    name: 'Результаты тестирований',
    path: 'testing-results'
  },
  'product-card-quality-controls': {
    key: 'product-card-quality-controls',
    name: 'Чек-лист контента',
    path: 'product-card-quality-controls'
  }
};
